

























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component
export default class MachineRentListHeader extends Vue {
  private isActive: boolean = false
  @Prop() private isCloseToggle!: boolean
  private doSort (name: string) {
    this.$emit('machine-rent-sort', name)
  }
  @Watch('isCloseToggle')
  private closeToggle (value: boolean) {
    this.isActive = !value
  }

  private active () {
    this.isActive = !this.isActive
    this.$emit('machine-rent-active', this.isActive)
  }
}
